export default function Testimonials() {
  return (
    <section className="w-full flex flex-col md:flex-row min-h-[460px] md:min-h-[500px]">
      <div className="w-full md:w-[60%] flex flex-col justify-center px-6 md:px-14 py-12 md:py-0 bg-background-50">
        <div className="max-w-lg">
          <div className="flex items-center gap-2 mb-8">
            <span className="w-2 h-2 rounded-full bg-foreground-900"></span>
            <p className="text-xs text-foreground-500 font-medium tracking-widest uppercase">Depoimentos</p>
          </div>

          <blockquote className="font-heading text-2xl md:text-3xl lg:text-4xl text-foreground-900 leading-relaxed mb-8">
            <span className="text-accent-600 text-4xl md:text-5xl">&ldquo;</span><br />
            O Hoobuy Spreadsheet mudou completamente a forma como compro produtos da China.
            Economizei centenas de euros e encontrei produtos incríveis que nunca teria descoberto sozinho.
          </blockquote>

          <div className="flex items-center gap-3">
            <div>
              <p className="text-sm font-semibold text-foreground-900">Miguel Santos</p>
              <div className="flex items-center gap-1.5 mt-0.5">
                <span className="w-3.5 h-3.5 flex items-center justify-center text-accent-600">
                  <i className="ri-star-fill text-xs"></i>
                </span>
                <span className="text-xs text-foreground-500">Verificado no Trustpilot</span>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="w-full md:w-[40%] min-h-[300px] md:min-h-full relative overflow-hidden">
        <img
          src="https://readdy.ai/api/search-image?query=Genuine%20happy%20person%20unboxing%20parcel%20with%20excitement%20holding%20new%20sneakers%20in%20modern%20living%20room%20with%20plants%20and%20natural%20daylight%2C%20authentic%20lifestyle%20moment%2C%20candid%20consumer%20photography%2C%20warm%20interior%20with%20Scandinavian%20decor%2C%20real%20joyful%20expression&width=800&height=900&seq=testimonial-v2&orientation=portrait"
          alt="Cliente satisfeito com Hoobuy Sheet"
          className="w-full h-full object-cover object-top"
        />
      </div>
    </section>
  );
}